export const getInvestorAccounts = state => state.user.investorAccounts
export const getSeachableMenu = state => state.menu.searchableMenu
